import {NeoModal} from "@/components/@modal/neo.modal";
import {DistanceDeviationReport} from "@/components/pages/dashboard/report-sidebar/distance-deviation";
import {DrivenReport} from "@/components/pages/dashboard/report-sidebar/driven-report";
import {SpeedDeviation} from "@/components/pages/dashboard/report-sidebar/speed-deviation";
import {TripStatus} from "@/components/pages/dashboard/report-sidebar/tripStatus";
import {RfidLog} from "@/components/pages/reports/report-sidebar/rfid-log";
import {NeoDocument} from "@/components/shared/neo-document/neo-document";
import {useNeoContext} from "@/context/neo/neo.context";
import {CommonConfig} from "@/data/common/commonData";
import {CustomerType} from "@/libs/enums/live";
import {convertMTOKM, encryptUrl} from "@/libs/helper";
import {formatCellValue as formatCellHelper} from "@/libs/helper/formatCellValue";
import {ExpenseService} from "@/service/expense.service";
import {tableService} from "@/service/table.service";
import {userService} from "@/service/users.service";
import {AllCommunityModule, ModuleRegistry} from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import {useRouter} from "next/navigation";
import {parseCookies, setCookie} from "nookies";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import toast from "react-hot-toast";
import {MdOutlineEdit} from "react-icons/md";
import {NeoTripTypeCells} from "../neo-column-chips/tripType";
import {NeoAction, NeoOption, NeoPickupDrop} from "../neo-fields";
import {NeoAssignedVehicle} from "../neo-fields/assignedVehicle";
import {NeoAttendance} from "../neo-fields/attendace";
import {NeoDateCell} from "../neo-fields/date";
import {NeoDuration} from "../neo-fields/duration";

import {
  NeoFuelCurrentLevel,
  formatFuelCurrentLevel
} from "../neo-fields/fuelCurrentLevel";
import {NeoFuelLocation, formatFuelLocation} from "../neo-fields/fuelLocation";
import {NeoFuelStatus, formatFuelStatus} from "../neo-fields/fuelStatus";
import {NeoFieldImage} from "../neo-fields/image";
import {NeoLocation} from "../neo-fields/location";
import {NeoSwipeLocation} from "../neo-fields/swipeLocation";
import {NeoSwipeVehicleTiming} from "../neo-fields/swipeVehicleTiming";
import {NeoTripFailureReason} from "../neo-fields/tripFailureReason";
import {
  NeoTripFailureType,
  formatTripFailureType
} from "../neo-fields/tripFailureType";
import {NeoAGHeader} from "../neo-table-header/neo-ag-grid-header";
import {SidebarDrawer} from "../neo-table-header/neo-agGrid-pivot";
import GroupingFilter from "./groupingFilter";
import {LoadingOverlay} from "./loaderNggrid";
import {useAgGridApi} from "./useAgGridApi";
/*@author: NeoTrack
    @description: This component is used to render ag-grid table
    Register all community modules with ag-grid
    We should add only those modules which we are using in our project. 
    Other wise it will increase the bundle size
    if you are using specific modules then you can register those modules here
*/
ModuleRegistry.registerModules([AllCommunityModule]);
const sKey: string = process.env.NEXT_PUBLIC_NEO_SECRET || "";

const sanitizeWorksheetName = (value: string) =>
  value.replace(/[\\/:*?[\]]/g, " ").slice(0, 31) || "Sheet1";

const commentOptions: string[] = [
  "",
  "Availing leave before or after public holiday",
  "Permission-1/2 hour(once)",
  "permission 2hrs",
  "Permission-1/2 hour(Second Time)",
  "Permission-1/2 hour(Third Time)",
  "Permission-1/2 hour(Fourth Time)",
  "Permission 1 hr (First Time)",
  "Availing leave before or after public holiday when Saturday is off",
  "New Joines availing leave within 6 months of joining",
  "Sick Leave 0 - 2 Days(First in the year)",
  "One time/Festive/Govt/Mgt Approved Partial day off",
  "On Duty Unpaid",
  "Permission-1/2 Day with LOP if other permission availed",
  "Non teaching staff absent",
  "On Duty Paid",
  "Permission - 1/2 Day without LOP if other permission is not availed",
  "Permission 1hr (Second Time)",
  "Sick Leave 0 - 2 Days(Repeated third time in a year with mgt permission)",
  "Special leave request- Exam Preparation",
  "Special leave request- Flexible timings",
  "3 Times late attendance=1/2 Casual Leave",
  "Sick Leave - 0 to 2 days ( Repeated second time in a year with mgt permission)",
  "Sick Leave - 3 to 7 days ( First in a year with mgt approval)",
  "Sick Leave - 8 to 15 days (Subject to mgt approval)",
  "Sick Leave - 8 to 15 days ( Without  mgt approval - First in the year)",
  "Sick Leave - 3 to 15 days ( Repeated in a year)",
  "Permission beyond 2 hours - 1/2 day Casual leave",
  "Immedate Death in family",
  "Casual Leave - More than 3 in one month(subject to not being public holiday rule)",
  "Part Time Staff absent",
  "Part Time Staff No Class",
  "1st Time late attendance",
  "2nd Time late attendance",
  "Casual Leave 01 ( in a year)",
  "Casual Leave 02 ( in a year)",
  "Casual Leave 03 ( in a year)",
  "Casual Leave 04 ( in a year)",
  "Casual Leave 05 ( in a year)",
  "Casual Leave 06 ( in a year)",
  "Casual Leave 07 ( in a year)",
  "Casual Leave 08 ( in a year)",
  "Casual Leave 09 ( in a year)",
  "Casual Leave 10 ( in a year)",
  "Casual Leave 11 ( in a year)",
  "Casual Leave 12 ( in a year)"
];

const monitoredEmployeeHearder: any = {
  Class: "Department",
  Section: "Branch",
  "Student Name": "Name",
  "Enroll No": "Employee ID",
  "Ref. Id/Admission No": "Employee ID",
  "ADMISSION NO": "EMPLOYEE ID",
  "Admission No": "Employee ID",
  CLASS: "DEPARTMENT",
  SECTION: "BRANCH"
};

export const NeoAGgrid: React.FC<NeoTableProps> = ({table}) => {
  const {apiRef, onGridReady} = useAgGridApi();
  // it's have basic information of active userID,instituteId,userName
  const {filterContext} = useNeoContext();
  const {push} = useRouter();
  const [actionType, setActionType] = useState<any | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>([]);
  const [rowsData, setRowData] = useState();
  const [checkedRows, setCheckedRows] = useState<any[]>([]);
  const {
    activeFilters, // which filter is active like (date,vehicle,trip tpe,attendance type)
    meta, // meta information of table like title,description,hasSearch,hasUpload,hasDownload,hasAdd,hasActions
    // columns, // columns of table like(columnHeader and uid)
    style, // h-full
    actions,
    url, // url of table like GET:"URL",POST:"URL",PUT:"URL",DELETE:"URL"
    dashboardfilter,
    sidebar, //sidebar information of table like (type,api_url,menu,sidebarHeading)
    tabView, //if we need tab view then we can use this
    innerFilters,
    headerSidebar,
    tabledatas,
    rowSelection,
    otherDatas,
    expensefilter, //Expense report filter trigger list fuction
    expensesummaryfilter, //Expense summary filter trigger add/edit after success fuction
    groupingFilter
  } = table;
  const gridRef = useRef<AgGridReact>(null);
  const [items, setItems] = useState<any[]>([]);

  const [columns, setColumns] = useState<any>(table.columns); //set report columns
  const isFuelDetailReport =
    columns.some((col: any) => col.uid === "currentFuelLevel") &&
    columns.some((col: any) => col.uid === "recentFillDate");
  const isTripFailureReport =
    columns.some((col: any) => col.uid === "actualUsers") &&
    columns.some((col: any) => col.uid === "reason");
  const [activeColumns, setActiveColumns] = useState<any>(table.activeColumns);
  const [visibleColumns, setVisibleColumns] = useState<Set<any>>(
    new Set(columns.map((col: any) => col.uid))
  );
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<TableResponse<any>>();
  const quickFilterTextRef = useRef("");

  // prevFilterValue used for checking if the filter value is changed
  //its use for when data.meta is empty not call the api for search box value
  const prevFilterValue = useRef<string | undefined>();

  /* Header Params start*/
  const cookies = parseCookies(null);
  const statusOptions = [
    {name: "Active", uid: "active"},
    {name: "InActive", uid: "inactive"}
  ];
  const [statusFilter, setStatusFilter] = useState<string | "">("");
  const [page, setPage] = useState(
    cookies["old.selected-page"] &&
      cookies["is-action-clicked"] &&
      typeof cookies["is-action-clicked"] === "string" &&
      JSON.parse(cookies["is-action-clicked"]).isaction
      ? JSON.parse(cookies["old.selected-page"]).page
      : 1
  );
  const [filters, setFilters] = useState({
    filterColumn: [],
    filterValues: []
  });
  const [reportFilters, setReportFilters] = useState<any>({});
  // dashboard - fuel filling and theft
  useEffect(() => {
    const isFuelFillingTheftTable =
      meta?.title === "Fuel Filling & Theft" ||
      url?.api?.get === "api/fuel/detailView";

    if (isFuelFillingTheftTable) {
      setReportFilters((prevFilters: any) => ({
        ...prevFilters,
        ...(dashboardfilter?.from && dashboardfilter?.to
          ? {
              from: dashboardfilter.from,
              to: dashboardfilter.to,
              filterType: "7"
            }
          : {})
      }));
    }
  }, [dashboardfilter?.from, dashboardfilter?.to]);

  // in grouping tab date change - group the data according to the date range
  const selectedTabKey = String(
    reportFilters?.filters?.type?.[0] ??
      reportFilters?.filters?.status?.[0] ??
      ""
  );
  const getConfiguredActiveColumns = (sourceColumns: any[] = table.columns) => {
    const validColumnUids = new Set(
      (sourceColumns || []).map((column: any) => column.uid)
    );
    const defaultActiveColumns = (table.activeColumns || []).filter(
      (uid: string) => validColumnUids.has(uid)
    );
    const fallbackColumns =
      defaultActiveColumns.length > 0
        ? defaultActiveColumns
        : (sourceColumns || []).map((column: any) => column.uid);
    const tabSpecificColumns = table.tabColumns?.[selectedTabKey];

    if (!tabSpecificColumns?.length) {
      return fallbackColumns;
    }

    const filteredTabColumns = tabSpecificColumns.filter((uid: string) =>
      validColumnUids.has(uid)
    );

    return filteredTabColumns.length > 0 ? filteredTabColumns : fallbackColumns;
  };

  // take active column alone not the api uid column.
  const applyConfiguredColumns = () => {
    const configuredColumns = table.columns || [];
    const configuredActiveColumns =
      getConfiguredActiveColumns(configuredColumns);

    setColumns(configuredColumns);
    setActiveColumns(configuredActiveColumns);
  };
  const [sidbarRequest, setSidebarRequest] = useState<any>();

  //Its used for showing sidebar columns for show and hide te column
  const [activePanel, setActivePanel] = useState<"columns" | "filters" | null>(
    null
  );
  // risk safety group by
  const [selectedGroupingFilter, setSelectedGroupingFilter] =
    useState<any>(null);
  const onSearchChange = useCallback(
    (value: string = "") => {
      const nextValue = value || "";

      quickFilterTextRef.current = nextValue;
      setPage(1);

      if (apiRef.current) {
        apiRef.current.setGridOption("quickFilterText", nextValue);
      }
    },
    [apiRef]
  );

  const handleGridReady = useCallback(
    (params: any) => {
      onGridReady(params);

      if (quickFilterTextRef.current) {
        params.api.setGridOption("quickFilterText", quickFilterTextRef.current);
      }
    },
    [onGridReady]
  );

  const applyFilters = (newFilters: any) => {
    setFilters(newFilters);
  };
  const applyReportFilters = (reportReq: any) => {
    // risk safety
    if (reportReq?.filters) {
      setSelectedGroupingFilter(null);
    }
    setReportFilters((prevFilters: any) => ({
      ...prevFilters,
      ...reportReq
    }));
  };
  const onChangeTab = (selectedKey: any) => {
    let status: any = [];
    if (selectedKey) {
      status = [selectedKey];
    }
    setReportFilters((prevFilters: any) => ({
      ...prevFilters,
      filters: {
        ...prevFilters.filters,
        type: status,
        status: status
      }
    }));
  };
  /* Header Params end*/
  //  API CALL
  const fetchData = async (groupingUrl: string | null = null) => {
    let actualUrl = url?.api?.get;
    let isGetMethod = false;
    if (actualUrl?.includes("loginUserId=")) {
      const [base, query] = actualUrl.split("loginUserId=");
      isGetMethod = true;
      actualUrl = `${base}loginUserId=${filterContext.client.institutionUserId}`;
    }
    if (groupingUrl) {
      actualUrl = groupingUrl;
    }
    const apiUrl = actualUrl;
    const req = {
      userId: filterContext.client.institutionUserId,
      instituteId: filterContext.client.institutionId,
      pageNumber: page,
      itemsPerPage: 100000,
      //filterValue old value in searchBy i removed beacuse of when i typed the vaue in
      // search box that value passed here so i set empty
      searchBy: "",
      //sortDescriptor?.column ? sortDescriptor?.column : ""
      sortColumn: "",
      //sortDescriptor?.direction === "descending"  ? "DESC"  : sortDescriptor?.direction === "ascending"  ? "ASC" : ""
      sortValue: "",
      filterColumn: filters?.filterColumn,
      filterValue: filters?.filterValues,
      ...reportFilters
    };
    const isFuelFillingTheftTable =
      meta?.title === "Fuel Filling & Theft" ||
      url?.api?.get === "api/fuel/detailView";

    if (isFuelFillingTheftTable) {
      if (reportFilters?.from && reportFilters?.to) {
        req.from = reportFilters.from;
        req.to = reportFilters.to;
        req.offset = reportFilters.offset;
        req.filterType = reportFilters.filterType;
      } else if (dashboardfilter?.from && dashboardfilter?.to) {
        req.from = dashboardfilter.from;
        req.to = dashboardfilter.to;
      }
    }
    if (!req.filters) {
      req.filters = {};
    }
    req.filters.trackers = req.filters.trackers || [];
    const trackerId = reportFilters.trackerId;
    const trackerIds = Array.isArray(trackerId)
      ? trackerId
      : trackerId
        ? [trackerId]
        : [];
    const existing = new Set(req.filters.trackers);
    for (const id of trackerIds) {
      if (!existing.has(id)) {
        req.filters.trackers.push(id);
        existing.add(id);
      }
    }
    if (
      Array.isArray(activeFilters) &&
      activeFilters.includes("vehicleSingle")
    ) {
      const trackerId = Array.isArray(reportFilters.trackerId)
        ? reportFilters.trackerId.join(",")
        : reportFilters.trackerId || "";
      req.trackerId = trackerId;
    }

    if (sidebar && sidebar.length > 0) {
      setSidebarRequest(req);
    } else {
      if (!req.trackerId || req.trackerId === "") {
        if (!req.from || !req.to) {
          return; // If no trackerId,from,to is provided, do not fetch data
        }
      }

      setIsLoading(true); // Start loading
      //console.log("starting");
      const results = await tableService.onGet(
        apiUrl,
        meta.id,
        req,
        isGetMethod
      );
      //console.log("results", results);

      if (results) {
        setData(results);
        setItems(Array.isArray(results?.rows) ? results.rows : []);
        if (
          results?.columns?.length > 0 &&
          // meta id 1-users,2-vehicles,3-driver,4-report,7-active routes
          (meta?.id === 4 || meta?.id === 7)
          // meta?.id === 1 ||
          // meta?.id === 2 ||
          // meta?.id === 3
        ) {
          //meta?.id =4 === result
          if (table.useConfiguredColumns) {
            applyConfiguredColumns();
          } else {
            const uidsArray = results.columns.map(
              (columnn: any) => columnn.uid
            );
            setColumns(results.columns);
            setActiveColumns(uidsArray);
          }
        } else {
          const uidsArray =
            meta?.id === 5
              ? getConfiguredActiveColumns(table.columns)
              : table.columns.map((columnn: any) => columnn.uid);
          setColumns(table.columns);
          setActiveColumns(uidsArray);
        }
        setIsLoading(false); // Stop loading
        //console.log("ending");
      }
    }
  };
  useEffect(() => {
    if (
      filterContext &&
      filterContext.client &&
      filterContext.client.institutionUserId &&
      filterContext.client.institutionId
    ) {
      if (table?.tabledatas) {
        //setData(table?.tabledatas);
        setData(prev => ({
          ...prev,
          rows: table?.tabledatas || []
        }));
        setItems(Array.isArray(table?.tabledatas) ? table.tabledatas : []);
        if (table?.columns.length > 0 && meta?.id === 0) {
          const uidsArray = table?.columns.map((columnn: any) => columnn.uid);
          setColumns(table?.columns);
          setActiveColumns(uidsArray);
        }
      } else {
        if (data && !data?.meta) {
          const currentFilterValue = quickFilterTextRef.current;

          if (
            currentFilterValue &&
            prevFilterValue.current !== currentFilterValue
          ) {
            prevFilterValue.current = currentFilterValue;
          } else {
            fetchData();
          }
        } else {
          fetchData();
        }
      }
    }
  }, [
    url,
    meta.id,
    //  rowsPerPage,
    //  page,
    // filterValue,
    filterContext,
    //sortDescriptor,
    // filters,
    reportFilters
  ]);

  useEffect(() => {
    if (meta?.id === 5) {
      setActiveColumns(getConfiguredActiveColumns(columns));
    }
  }, [
    meta?.id,
    columns,
    selectedTabKey,
    table.activeColumns,
    table.tabColumns
  ]);

  //AG GRID Cobnfiguration
  // column definition
  const handleAction = useCallback(
    (key: any, id: any, row: any) => {
      const item = actions?.find(x => x.key == key);
      if (meta?.id === 6) {
        if (key == "delete") {
          setActionType({key: "delete"});
          setModalData(row);
          onModalOpen();
        } else if (url?.page?.edit === "fueledit" && row) {
          setActionType({key: "fuelform"});
          setModalData(row);
          onModalOpen();
        } else if (url?.page?.edit === "maintenanceedit" && row) {
          setActionType({key: "maintenanceform"});
          setModalData(row);
          onModalOpen();
        } else if (url?.page?.edit === "miscellaneousedit" && row) {
          setActionType({key: "miscellaneousform"});
          setModalData(row);
          onModalOpen();
        }
      } else {
        if (item) {
          if (item.type === "navigate") {
            const route = (url.page as any)[key];
            const navigate = async () => {
              const navId = await encryptUrl(row.id, sKey);
              const routeWithId = route
                ? route.replace("${navId}", navId)
                : route;
              push(routeWithId);
            };
            setCookie(
              null,
              "is-action-clicked",
              JSON.stringify({isaction: true}),
              {
                maxAge: 30 * 24 * 60 * 60,
                path: "/",
                sameSite: "none",
                secure: true
              }
            );
            navigate();
          } else {
            if (item.key === "addeditDriver") {
              openFormModal("addeditDriver", true, row.id);
            } else {
              setActionType(item);
              setRowData(row);
              onModalOpen();
            }
          }
        } else {
          console.error(
            "Invalid table configuration, Please check the relevant table configuration"
          );
        }
      }
    },
    [actions, push, url]
  );
  const onModalOpen = () => {
    setModalOpen(true);
  };
  const openFormModal = (
    modalType: string,
    ismodalOpen: boolean,
    driverId: any = ""
  ) => {
    setActionType({key: modalType});
    setModalOpen(ismodalOpen);
    if (driverId) {
      setModalData({driverId: driverId});
    } else {
      setModalData({});
    }
  };

  const yesNoFormatter = (value: any) => (value === 1 ? "Yes" : "No");
  const activeInactiveFormatter = (value: any) =>
    Number(value) === 1 ? "Active" : "Inactive";
  const yesNoFilterConfig = (colId: string) => ({
    valueFormatter: (params: any) => yesNoFormatter(params.value),
    filterValueGetter: (params: any) => yesNoFormatter(params.data?.[colId]),
    getQuickFilterText: (params: any) => yesNoFormatter(params.data?.[colId]),
    filter: "agTextColumnFilter",
    filterParams: {
      values: ["Yes", "No"]
    }
  });
  const activeInactiveFilterConfig = (colId: string) => ({
    valueFormatter: (params: any) =>
      activeInactiveFormatter(params.data?.[colId]),
    filterValueGetter: (params: any) =>
      activeInactiveFormatter(params.data?.[colId]),
    getQuickFilterText: (params: any) =>
      activeInactiveFormatter(params.data?.[colId]),
    filter: "agSetColumnFilter",
    filterParams: {
      values: ["Active", "Inactive"]
    }
  });
  const objectArrayFilterConfig = (colId: string) => ({
    getQuickFilterText: (params: any) => {
      const data = params.data?.[colId];
      if (Array.isArray(data))
        return data.map((item: any) => item.name).join(", ");
      if (data?.name) return data.name;
      return "";
    },
    filterValueGetter: (params: any) => {
      const data = params.data?.[colId];
      if (Array.isArray(data))
        return data.map((item: any) => item.name).join(", ");
      if (data?.name) return data.name;
      return "";
    },
    filter: "agTextColumnFilter"
  });

  const cellrenderFactory = (col: any, cellType: string) => {
    const result =
      col.type === "Date" ||
      col.type === "Datetime" ||
      col.type === "Time" ||
      col.type === "DateTimeSeconds"
        ? (params: any) => {
            return cellType === "cellRenderer" ? (
              <NeoDateCell
                data={params.data}
                cellValue={params.data[col.uid]}
                type={col.type}
              />
            ) : params.data[col.uid] ? (
              // formatCellHelper.formatTimeStampCellValue(
              //   params.data[col.uid],
              //   col.type
              // )

              col.type === "Time" && Array.isArray(params.data[col.uid]) ? (
                params.data[col.uid]
                  .map((ts: any) =>
                    formatCellHelper.formatTimestamp(ts, col.type)
                  )
                  .join(" , ")
              ) : (
                formatCellHelper.formatTimestamp(params.data[col.uid], col.type)
              )
            ) : (
              "-"
            );
          }
        : isFuelDetailReport && formatCellHelper.fuelDateColumnUids.has(col.uid)
          ? (params: any) =>
              formatCellHelper.formatFuelDateTime(params.data?.[col.uid])
          : col.type === "SwipeLocations"
            ? (params: any) => {
                return cellType === "cellRenderer" ? (
                  <NeoSwipeLocation data={params.data} uid={col.uid} />
                ) : (
                  formatCellHelper.formatSwipeLocationValue(
                    params.data[col.uid]
                  )
                );
              }
            : col.type === "SwipeTimings"
              ? (params: any) => {
                  return cellType === "cellRenderer" ? (
                    <NeoSwipeVehicleTiming data={params.data} uid={col.uid} />
                  ) : (
                    formatCellHelper.formatSwipeVehicleTimingValue(
                      params.data[col.uid]
                    )
                  );
                }
              : col.type === "Duration"
                ? (params: any) => {
                    return cellType === "cellRenderer" ? (
                      <NeoDuration data={params.data} uid={col.uid} />
                    ) : (
                      formatCellHelper.formatDuration(params.data[col.uid])
                    );
                  }
                : col.type === "Locations"
                  ? (params: any) => {
                      return cellType === "cellRenderer" ? (
                        <NeoLocation data={params.data} uid={col.uid} />
                      ) : (
                        formatCellHelper.formatLocation(params.data[col.uid])
                      );
                    }
                  : col.type === "attendance"
                    ? (params: any) => {
                        return cellType === "cellRenderer" ? (
                          <NeoAttendance data={params.data} uid={col.uid} />
                        ) : formatCellHelper.formatAttendance(
                            params.data[col.uid]
                          ) ? (
                          "Present"
                        ) : (
                          "Absent"
                        );
                      }
                    : col.uid === "tripType"
                      ? (params: any) => {
                          return cellType === "cellRenderer" ? (
                            <NeoTripTypeCells value={params.data[col.uid]} />
                          ) : formatCellHelper.formatTripType(
                              params.data[col.uid]
                            ) ? (
                            "Pickup"
                          ) : (
                            "Drop"
                          );
                        }
                      : isFuelDetailReport && col.uid === "type"
                        ? (params: any) => {
                            return cellType === "cellRenderer" ? (
                              <NeoFuelStatus data={params.data} uid={col.uid} />
                            ) : (
                              formatFuelStatus(params.data?.[col.uid])
                            );
                          }
                        : isTripFailureReport && col.uid === "type"
                          ? (params: any) => {
                              return cellType === "cellRenderer" ? (
                                <NeoTripFailureType
                                  data={params.data}
                                  uid={col.uid}
                                />
                              ) : (
                                formatTripFailureType(params.data?.[col.uid])
                              );
                            }
                          : isTripFailureReport && col.uid === "reason"
                            ? (params: any) => {
                                return cellType === "cellRenderer" ? (
                                  <NeoTripFailureReason
                                    data={params.data}
                                    uid={col.uid}
                                  />
                                ) : (
                                  (params.data?.[col.uid] ?? "-")
                                );
                              }
                            : isFuelDetailReport &&
                                col.uid === "currentFuelLevel"
                              ? (params: any) => {
                                  return cellType === "cellRenderer" ? (
                                    <NeoFuelCurrentLevel
                                      data={params.data}
                                      uid={col.uid}
                                    />
                                  ) : (
                                    formatFuelCurrentLevel(params.data, col.uid)
                                  );
                                }
                              : isFuelDetailReport && col.uid === "location"
                                ? (params: any) => {
                                    return cellType === "cellRenderer" ? (
                                      <NeoFuelLocation data={params.data} />
                                    ) : (
                                      formatFuelLocation(params.data)
                                    );
                                  }
                                : col.uid === "actions"
                                  ? (params: any) => (
                                      <NeoAction
                                        data={params.data}
                                        actions={actions?.filter(
                                          (action: any) => action.isVisible
                                        )}
                                        meta={meta}
                                        handleAction={handleAction}
                                      />
                                    )
                                  : // : col.uid === "status" && meta?.id === 4 // 4 - report
                                    //   ? (params: any) =>
                                    //       params.data.status === 0 ||
                                    //       params.data.status === 1 ? (
                                    //         <NeoStatus
                                    //           status={
                                    //             params.data.status == 0
                                    //               ? ActiveStatus.INACTIVE
                                    //               : ActiveStatus.ACTIVE
                                    //           }
                                    //         />
                                    //       ) : (
                                    //         params.data.status
                                    //       )
                                    col.uid === "appStatus"
                                    ? (params: any) => {
                                        return cellType === "cellRenderer" ? (
                                          <NeoOption
                                            data={params.data}
                                            cellValue={params.data.appStatus}
                                          />
                                        ) : (
                                          formatCellHelper.formatYesNoOptions(
                                            params.data[col.uid]
                                          )
                                        );
                                      }
                                    : meta?.id === 1 && col.uid === "pickup"
                                      ? (params: any) => (
                                          <NeoPickupDrop
                                            data={params.data.pickup}
                                          />
                                        )
                                      : meta?.id === 1 && col.uid === "drop"
                                        ? (params: any) => (
                                            <NeoPickupDrop
                                              data={params.data.drop}
                                            />
                                          )
                                        : meta?.id === 6 &&
                                            col.uid === "documents"
                                          ? (params: any) => (
                                              <NeoDocument
                                                data={params.data.documents}
                                                onClick={() =>
                                                  onDocumentModalOpen(
                                                    params.data
                                                  )
                                                }
                                              />
                                            )
                                          : col.uid === "operation"
                                            ? (params: any) => {
                                                const currentOpertionData =
                                                  CommonConfig.opertion.find(
                                                    operVal =>
                                                      operVal.id ===
                                                      params.data[col.uid]
                                                  );
                                                //CommonConfig
                                                return (
                                                  currentOpertionData?.name ??
                                                  ""
                                                );
                                              }
                                            : col.uid === "totalDistance"
                                              ? (params: any) => {
                                                  return convertMTOKM(
                                                    params.data[col.uid]
                                                  );
                                                }
                                              : col.uid === "image"
                                                ? (params: any) => (
                                                    <NeoFieldImage
                                                      data={params.data}
                                                      uid={col.uid}
                                                    />
                                                  )
                                                : col.uid === "transport"
                                                  ? (parms: any) =>
                                                      parms.data[col.uid] === 1
                                                        ? "Yes"
                                                        : "No"
                                                  : col.uid === "tripInfo"
                                                    ? (params: any) => (
                                                        <NeoFieldImage
                                                          data={params.data}
                                                          uid={col.uid}
                                                        />
                                                      )
                                                    : meta?.id === 8 &&
                                                        col.uid ===
                                                          "description"
                                                      ? (params: any) =>
                                                          params.data?.[col.uid]
                                                            ?.toString()
                                                            .trim() || "N/A"
                                                      : col.uid === "comments"
                                                        ? (params: any) => {
                                                            return cellType ===
                                                              "cellRenderer" ? (
                                                              <div className="flex w-full items-center justify-between gap-2">
                                                                <span className="truncate">
                                                                  {params.data
                                                                    .comments ||
                                                                    "-"}
                                                                </span>
                                                                <button
                                                                  type="button"
                                                                  title="Edit comment"
                                                                  className="shrink-0 text-gray-400 hover:text-gray-700"
                                                                  onClick={e => {
                                                                    e.stopPropagation();
                                                                    params.api.startEditingCell(
                                                                      {
                                                                        rowIndex:
                                                                          params
                                                                            .node
                                                                            .rowIndex,
                                                                        colKey:
                                                                          "comments"
                                                                      }
                                                                    );
                                                                  }}
                                                                >
                                                                  <MdOutlineEdit
                                                                    size={16}
                                                                  />
                                                                </button>
                                                              </div>
                                                            ) : (
                                                              params.data
                                                                .comments
                                                            );
                                                          }
                                                        : col.uid === "assigned"
                                                          ? (params: any) => {
                                                              return cellType ===
                                                                "cellRenderer" ? (
                                                                <NeoAssignedVehicle
                                                                  data={
                                                                    params.data
                                                                  }
                                                                  uid={col.uid}
                                                                />
                                                              ) : (
                                                                formatCellHelper.formatYesNoOptions(
                                                                  params.data[
                                                                    col.uid
                                                                  ]
                                                                )
                                                              );
                                                            }
                                                          : col.type ===
                                                              "VisitorImage"
                                                            ? (params: any) =>
                                                                cellType ===
                                                                "cellRenderer" ? (
                                                                  <NeoFieldImage
                                                                    data={
                                                                      params.data
                                                                    }
                                                                    uid={
                                                                      col.uid
                                                                    }
                                                                  />
                                                                ) : (
                                                                  params.data[
                                                                    col.uid
                                                                  ] || ""
                                                                )
                                                            : col.type ===
                                                                "VisitorType"
                                                              ? (
                                                                  params: any
                                                                ) => {
                                                                  const v =
                                                                    String(
                                                                      params
                                                                        .data[
                                                                        col.uid
                                                                      ]
                                                                    );
                                                                  return v ===
                                                                    "1"
                                                                    ? "Guardian Visitor"
                                                                    : v === "2"
                                                                      ? "Walk in Visitor"
                                                                      : v;
                                                                }
                                                              : col.type ===
                                                                  "PickedUpStudents"
                                                                ? (
                                                                    params: any
                                                                  ) => {
                                                                    const list =
                                                                      params
                                                                        .data[
                                                                        col.uid
                                                                      ];
                                                                    if (
                                                                      !Array.isArray(
                                                                        list
                                                                      ) ||
                                                                      !list.length
                                                                    )
                                                                      return "-";
                                                                    return list
                                                                      .map(
                                                                        (
                                                                          s: any
                                                                        ) =>
                                                                          s?.className
                                                                            ? `${s.studentName} (${s.className})`
                                                                            : s?.studentName ||
                                                                              ""
                                                                      )
                                                                      .filter(
                                                                        Boolean
                                                                      )
                                                                      .join(
                                                                        ", "
                                                                      );
                                                                  }
                                                                : col.type ===
                                                                    "ComplianceGroup"
                                                                  ? (
                                                                      params: any
                                                                    ) => {
                                                                      const details =
                                                                        params
                                                                          .data
                                                                          ?.details;
                                                                      if (
                                                                        !Array.isArray(
                                                                          details
                                                                        )
                                                                      )
                                                                        return "-";
                                                                      const matches =
                                                                        details.filter(
                                                                          (
                                                                            d: any
                                                                          ) =>
                                                                            d?.status ===
                                                                            col.statusValue
                                                                        );
                                                                      if (
                                                                        !matches.length
                                                                      )
                                                                        return "-";
                                                                      return cellType ===
                                                                        "cellRenderer" ? (
                                                                        <div className="flex flex-col gap-0.5 py-1">
                                                                          {matches.map(
                                                                            (
                                                                              d: any,
                                                                              i: number
                                                                            ) => (
                                                                              <div
                                                                                key={
                                                                                  i
                                                                                }
                                                                                className="text-xs"
                                                                              >
                                                                                {
                                                                                  d.typeName
                                                                                }
                                                                                {d.expiryDate
                                                                                  ? ` - ${d.expiryDate}`
                                                                                  : ""}
                                                                              </div>
                                                                            )
                                                                          )}
                                                                        </div>
                                                                      ) : (
                                                                        matches
                                                                          .map(
                                                                            (
                                                                              d: any
                                                                            ) =>
                                                                              d.expiryDate
                                                                                ? `${d.typeName} - ${d.expiryDate}`
                                                                                : d.typeName
                                                                          )
                                                                          .join(
                                                                            ", "
                                                                          )
                                                                      );
                                                                    }
                                                                  : undefined;
    return result;
  };
  const dynamicHeader = (label: string) => {
    //monitoredEmployeeHearder
    //console.log(filterContext);
    if (filterContext?.client?.customerType === CustomerType.EMPLOYEETRACKING) {
      return monitoredEmployeeHearder[label] || label;
    }
    return label;
  };
  const headerColumns = useMemo<any>(() => {
    if (!columns || columns.length === 0) {
      //  console.log("No columns available");
      return [];
    }
    // console.log("Visible Columns Set:", visibleColumns);
    // console.log("All Columns:", columns);

    const filteredColumns = columns.filter((column: any) =>
      Array.from(activeColumns).includes(column.uid)
    );
    // console.log("Active Columns Set:", filteredColumns);

    return filteredColumns.map((col: any) => {
      const isActionColumn = col.uid === "actions";
      const isAmountCol = [
        "amount",
        "total",
        "fuel",
        "maintenance",
        "misc",
        "maxExpense",
        "totalCost",
        "fuelRate",
        "qty"
      ].includes(col.uid);

      const colDef: any = {
        headerName: dynamicHeader(col.name),
        field: col.uid,
        sortable: true,
        resizable: true,
        editable: col.uid === "comments" ? true : false,
        ...(col.uid === "comments" && {
          cellEditor: "agSelectCellEditor",
          cellEditorParams: {
            values: commentOptions
          }
        }),
        // hide filter
        filter: col.uid === "" ? false : col.uid === "rating" ? false : true,
        wrapHeaderText: true,
        headerCheckboxSelection: col?.checkbox,
        checkboxSelection: col?.checkbox,
        width: isActionColumn
          ? 100
          : col.uid === "msg"
            ? 800
            : col.type === "SwipeTimings"
              ? 300
              : col.type === "ComplianceGroup"
                ? 220
                : 180,
        minWidth: isActionColumn ? 88 : undefined,
        maxWidth: isActionColumn ? 108 : undefined,
        cellClass: isActionColumn
          ? "neo-ag-grid-actions-cell"
          : "allow-text-select",
        headerClass: isActionColumn ? "neo-ag-grid-actions-header" : undefined,
        wrapText: col.uid === "msg" || col.type === "ComplianceGroup",
        autoHeight: col.uid === "msg" || col.type === "ComplianceGroup",
        pinned: isActionColumn
          ? "right"
          : [
                "image",
                "vehicleName",
                "date",
                "name",
                "incompleteSwipe",
                "wrongSwipe"
              ].includes(col.uid)
            ? "left"
            : false,
        ...(col.uid === "sno" && {pinned: "left"}),
        ...(isActionColumn && {
          filter: false,
          lockPinned: true,
          lockPosition: "right",
          resizable: false,
          sortable: false,
          suppressMovable: true
        }),
        ...(col.uid === "appStatus" && yesNoFilterConfig(col.uid)),
        // ...(col.uid === "status" && activeInactiveFilterConfig(col.uid)),
        ...(col.uid === "pickup" && objectArrayFilterConfig("pickup")),
        ...(col.uid === "drop" && objectArrayFilterConfig("drop")),
        cellRenderer: cellrenderFactory(col, "cellRenderer"),
        valueGetter: cellrenderFactory(col, "valueGetter")
      };

      if (isAmountCol) {
        colDef.comparator = (valueA: any, valueB: any) => {
          const a = parseFloat(String(valueA).replace(/,/g, "")) || 0;
          const b = parseFloat(String(valueB).replace(/,/g, "")) || 0;
          return a - b;
        };
      }
      if (col.uid === "time") {
        colDef.comparator = (valueA: any, valueB: any) => {
          const dateA = new Date(valueA);
          const dateB = new Date(valueB);
          return dateA.getTime() - dateB.getTime();
        };
      }
      return colDef;
    });
  }, [visibleColumns, activeColumns]);

  const onExportClick = async () => {
    const api = apiRef.current;
    if (!api) return;
    try {
      const {utils, writeFileXLSX} = await import("xlsx");
      const reportHeader = meta?.title ? `${meta.title}` : "export-excel";
      const fileName = `${reportHeader}-${new Date().toISOString().slice(0, 10)}.xlsx`;
      const sheetName = sanitizeWorksheetName(reportHeader);

      const exportColumns = api
        .getAllGridColumns()
        .filter(
          col => col.getColId() !== "actions" && col.getColId() !== "documents"
        );

      const getExportCellValue = (colId: string, data: any, value: any) => {
        switch (colId) {
          case "status":
            return meta.id === 4
              ? data?.status === 0
                ? "Inactive"
                : data?.status === 1
                  ? "Active"
                  : data?.status
              : data?.status;
          case "pickup":
            return Array.isArray(data?.pickup)
              ? data?.pickup.map((p: any) => p.name).join(", ")
              : "";
          case "drop":
            return Array.isArray(data?.drop)
              ? data?.drop.map((d: any) => d.name).join(", ")
              : "";
          case "appStatus":
            return data?.appStatus === 0 ? "No" : "Yes";
          default:
            return value;
        }
      };

      const rows: any[][] = [
        exportColumns.map(
          column => column.getColDef().headerName || column.getColId()
        )
      ];

      api.forEachNodeAfterFilterAndSort((node: any) => {
        rows.push(
          exportColumns.map(column => {
            const colId = column.getColId();
            return String(
              getExportCellValue(
                colId,
                node.data,
                api.getCellValue({
                  rowNode: node,
                  colKey: colId,
                  useFormatter: true
                })
              ) ?? ""
            );
          })
        );
      });

      const worksheet = utils.aoa_to_sheet(rows);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, sheetName);
      writeFileXLSX(workbook, fileName);
    } catch (error) {
      console.error("Failed to export Excel file", error);
      toast.error("Failed to export Excel file");
    }
  };

  const onModalClose = () => {
    const closedActionKey = actionType?.key;
    setModalOpen(false);
    setActionType(null);
    setRowData(undefined);

    if ((meta.id === 3 || meta.id === 1) && closedActionKey !== "bpHistory") {
      // 3 - Driver , 1 - User
      fetchData();
    } else if (meta.id === 6) {
      setModalData({});
    }
  };

  const onModalSubmit = async (data: any) => {
    if (meta?.id === 6) {
      const loginuserid = filterContext.client.institutionUserId;
      const bulkExpenseTypeMap: Record<string, number> = {
        fuelform: 1,
        maintenanceform: 2,
        miscellaneousform: 3
      };

      if (actionType?.key == "delete" && modalData?.id) {
        const ids = [];
        ids.push(modalData?.id);
        const requestdata: any = {
          ids: ids,
          type: modalData?.reportType
        };
        const response: any = await ExpenseService.deleteExpense(
          loginuserid,
          requestdata
        );

        /*if (modalData?.reportType == 1) {
          response = await ExpenseService.deletefuelexpense(
            loginuserid,
            requestdata
          );
        } else if (modalData?.reportType == 2) {
          response = await ExpenseService.deletemaintenanceexpense(
            loginuserid,
            requestdata
          );
        } else if (modalData?.reportType == 3) {
          response = await ExpenseService.deletemiscellaneousexpense(
            loginuserid,
            requestdata
          );
        }*/

        if (response?.data?.status === "success") {
          toast.success(response?.data?.message);
          if (typeof expensefilter === "function") {
            expensefilter();
          }
          if (typeof expensesummaryfilter === "function") {
            expensesummaryfilter();
          }
          setModalOpen(false);
        } else {
          toast.error(response?.data?.message);
        }
      } else if (
        data?.bulkUpload &&
        bulkExpenseTypeMap[actionType?.key as string]
      ) {
        if (!data?.excelFile) {
          toast.error("Please upload an Excel file.");
          return;
        }

        const fd = new FormData();
        fd.append(
          "Type",
          String(bulkExpenseTypeMap[actionType?.key as string])
        );
        fd.append("excelFile", data.excelFile, data.excelFile.name);

        const response = await ExpenseService.addexpenselist(loginuserid, fd);

        if (response?.data?.status === "success") {
          toast.success(response?.data?.message);
          if (typeof expensefilter === "function") {
            expensefilter?.();
          }
          if (typeof expensesummaryfilter === "function") {
            expensesummaryfilter();
          }
          setModalOpen(false);
        } else {
          toast.error(response?.data?.message);
        }
        return;
      } else if (
        actionType?.key === "fuelform" &&
        (url?.page?.add === "fueladd" ||
          url?.page?.edit === "fueledit" ||
          url?.page?.add === "expensesadd")
      ) {
        const idx = 0;
        const vehicleId = Number(data.vehicleId);

        const date =
          data.date instanceof Date ? data.date : new Date(data.date);
        /*const now = new Date();
        const currentHours = now.getHours();
        const currentMinutes = now.getMinutes();
        const currentSeconds = now.getSeconds();
        mergedDate.setHours(0, 0, 0, 0);
        const dateMs = mergedDate.getTime();*/
        const dateMs =
          date instanceof Date
            ? Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0,
                0,
                1
              )
            : undefined;
        const qty = Number(data.qty);
        const totalAmount = Number(data.totalAmount);
        const fuelRate = Number(data.fuelRate);
        const fuelType = Number(data.fuelType);
        const fuelStationId =
          data.fuelStationId === "" || data.fuelStationId == null
            ? null
            : Number(data.fuelStationId);
        const description = data.description ?? "";
        const odometerReading =
          data.odometerReading == null ? null : Number(data.odometerReading);

        const fd = new FormData();
        fd.append(`requests[${idx}].vehicleId`, String(vehicleId));
        fd.append(`requests[${idx}].date`, String(dateMs));
        fd.append(`requests[${idx}].qty`, String(qty));
        fd.append(`requests[${idx}].totalAmount`, String(totalAmount));
        fd.append(`requests[${idx}].fuelRate`, String(fuelRate));
        fd.append(`requests[${idx}].fuelType`, String(fuelType));
        if (fuelStationId === null || fuelStationId === 0) {
          fd.append(`requests[${idx}].fuelStationId`, "");
        } else {
          fd.append(`requests[${idx}].fuelStationId`, String(fuelStationId));
        }
        fd.append(`requests[${idx}].description`, description);
        if (odometerReading === null || odometerReading === 0) {
          fd.append(`requests[${idx}].odometerReading`, "");
        } else {
          fd.append(
            `requests[${idx}].odometerReading`,
            String(odometerReading)
          );
        }

        if (data?.id) {
          fd.append(`requests[${idx}].id`, String(data?.id));
        }

        if (data.attachments?.length) {
          data.attachments.forEach((att: any, aIdx: any) => {
            if (att.file) {
              fd.append(
                `requests[${idx}].documents[${aIdx}]`,
                att.file,
                att.name
              );
            }
          });
        }

        let response: any = {};
        if (data?.id) {
          response = await ExpenseService.updatefuelexpense(loginuserid, fd);
        } else {
          response = await ExpenseService.addfuelexpense(loginuserid, fd);
        }

        if (response?.data?.status === "success") {
          toast.success(response?.data?.message);
          if (typeof expensefilter === "function") {
            expensefilter?.();
          }
          if (typeof expensesummaryfilter === "function") {
            expensesummaryfilter();
          }
          setModalOpen(false);
        } else {
          toast.error(response?.data?.message);
        }
      } else if (
        actionType?.key == "maintenanceform" &&
        (url?.page?.add === "maintenanceadd" ||
          url?.page?.edit === "maintenanceedit" ||
          url?.page?.add === "expensesadd")
      ) {
        const idx = 0;
        const vehicleId = Number(data.vehicleId);

        const date =
          data.date instanceof Date ? data.date : new Date(data.date);
        /*const now = new Date();
        const currentHours = now.getHours();
        const currentMinutes = now.getMinutes();
        const currentSeconds = now.getSeconds();
        const mergedDate = new Date(date);
        mergedDate.setHours(0, 0, 0, 0);
        const dateMs = mergedDate.getTime();*/
        const dateMs =
          date instanceof Date
            ? Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0,
                0,
                1
              )
            : undefined;
        const totalAmount = Number(data.totalAmount);
        const expenseType =
          data.expenseType === "" || data.expenseType == null
            ? null
            : Number(data.expenseType);
        const description = data.description ?? "";
        const vendorId = data.vendorId == null ? null : Number(data.vendorId);

        const fd = new FormData();
        fd.append(`requests[${idx}].vehicleId`, String(vehicleId));
        fd.append(`requests[${idx}].date`, String(dateMs));
        fd.append(`requests[${idx}].totalAmount`, String(totalAmount));
        if (expenseType === null) {
          fd.append(`requests[${idx}].expenseType`, "");
        } else {
          fd.append(`requests[${idx}].expenseType`, String(expenseType));
        }
        fd.append(`requests[${idx}].description`, description);
        if (vendorId === null || vendorId === 0) {
          fd.append(`requests[${idx}].vendorId`, "");
        } else {
          fd.append(`requests[${idx}].vendorId`, String(vendorId));
        }

        if (data?.id) {
          fd.append(`requests[${idx}].id`, String(data?.id));
        } else {
          if (data.attachments?.length) {
            data.attachments.forEach((att: any, aIdx: any) => {
              if (att.file) {
                fd.append(
                  `requests[${idx}].documents[${aIdx}]`,
                  att.file,
                  att.name
                );
              }
            });
          }
        }

        let response: any = {};
        if (data?.id) {
          response = await ExpenseService.updatemaintenanceexpense(
            loginuserid,
            fd
          );
        } else {
          response = await ExpenseService.addmaintenanceexpense(
            loginuserid,
            fd
          );
        }

        if (response?.data?.status === "success") {
          toast.success(response?.data?.message);
          if (typeof expensefilter === "function") {
            expensefilter?.();
          }
          if (typeof expensesummaryfilter === "function") {
            expensesummaryfilter();
          }
          setModalOpen(false);
        } else {
          toast.error(response?.data?.message);
        }
      } else if (
        actionType?.key == "miscellaneousform" &&
        (url?.page?.add === "miscellaneousadd" ||
          url?.page?.edit === "miscellaneousedit" ||
          url?.page?.add === "expensesadd")
      ) {
        const idx = 0;
        const vehicleId = Number(data.vehicleId);

        const date =
          data.date instanceof Date ? data.date : new Date(data.date);
        /*const now = new Date();
        const currentHours = now.getHours();
        const currentMinutes = now.getMinutes();
        const currentSeconds = now.getSeconds();
        const mergedDate = new Date(date);
        mergedDate.setHours(0, 0, 0, 0);
        const dateMs = mergedDate.getTime();*/
        const dateMs =
          date instanceof Date
            ? Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0,
                0,
                1
              )
            : undefined;
        const totalAmount = Number(data.totalAmount);
        const expenseType =
          data.expenseType === "" || data.expenseType == null
            ? null
            : Number(data.expenseType);
        const description = data.description ?? "";

        const fd = new FormData();
        fd.append(`requests[${idx}].vehicleId`, String(vehicleId));
        fd.append(`requests[${idx}].date`, String(dateMs));
        fd.append(`requests[${idx}].totalAmount`, String(totalAmount));
        if (expenseType === null) {
          fd.append(`requests[${idx}].expenseType`, "");
        } else {
          fd.append(`requests[${idx}].expenseType`, String(expenseType));
        }
        fd.append(`requests[${idx}].description`, description);

        if (data?.id) {
          fd.append(`requests[${idx}].id`, String(data?.id));
        } else {
          if (data.attachments?.length) {
            data.attachments.forEach((att: any, aIdx: any) => {
              if (att.file) {
                fd.append(
                  `requests[${idx}].documents[${aIdx}]`,
                  att.file,
                  att.name
                );
              }
            });
          }
        }

        let response: any = {};
        if (data?.id) {
          response = await ExpenseService.updatemiscellaneousexpense(
            loginuserid,
            fd
          );
        } else {
          response = await ExpenseService.addmiscellaneousexpense(
            loginuserid,
            fd
          );
        }

        if (response?.data?.status === "success") {
          toast.success(response?.data?.message);
          if (typeof expensefilter === "function") {
            expensefilter?.();
          }
          if (typeof expensesummaryfilter === "function") {
            expensesummaryfilter();
          }
          setModalOpen(false);
        } else {
          toast.error(response?.data?.message);
        }
      } else if (
        actionType?.key === "expensesadd" &&
        url?.page?.add === "expensesadd"
      ) {
        setModalOpen(false);
        if (data == 1) {
          setActionType({key: "fuelform"});
          setModalOpen(true);
        } else if (data == 2) {
          setActionType({key: "maintenanceform"});
          setModalOpen(true);
        } else if (data == 3) {
          setActionType({key: "miscellaneousform"});
          setModalOpen(true);
        }
      } else if (actionType?.key === "documentgrid") {
        if (data?.operation == "documentdelete") {
          const requestdata = {id: data?.id};
          const response = await ExpenseService.deletedocument(
            loginuserid,
            requestdata
          );
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            if (typeof expensefilter === "function") {
              expensefilter?.();
            }
            setModalOpen(false);
          } else {
            toast.error(response?.data?.message);
          }
        } else {
          const fd = new FormData();
          fd.append("expenseType", String(data.expenseType));
          fd.append("expenseRefId", String(data.expenseRefId));
          data.files.forEach((att: any, aIdx: any) => {
            if (att.file) {
              fd.append("files", att.file, att.name);
            }
          });
          const response = await ExpenseService.documentupload(loginuserid, fd);
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            if (typeof expensefilter === "function") {
              expensefilter?.();
            }
            setModalOpen(false);
          } else {
            toast.error(response?.data?.message);
          }
        }
      }
    } else {
      const actionUrl = (url.api as any)[actionType?.key];
      if (actionUrl) {
        await tableService
          .onPut(
            meta.id,
            filterContext.client.institutionUserId,
            actionUrl,
            actionType?.key,
            data,
            filterContext.client.institutionId
          )
          .then(async () => {
            if (meta.id === 3 && actionType?.key === "delete") {
              await fetchData();
            }
          })
          .finally(() => {
            setModalOpen(false);
          });
      } else {
        console.error(
          "Invalid table configuration, Please check the relevant table configuration"
        );
      }
    }
  };
  const onRowDoubleClicked = useCallback(
    (event: any) => {
      const row = event?.data;
      // 1 - User, 2 - Vehicle, 3 - Driver
      if (!row || ![1, 2, 3].includes(meta?.id)) {
        return;
      }
      const primaryAction =
        actions?.find(
          (action: any) => action.key === "view" && action.isVisible
        ) ??
        actions?.find(
          (action: any) => action.type === "navigate" && action.isVisible
        );
      if (primaryAction) {
        const contextId = row.driverId ?? row.vehicleId ?? row.userId ?? row.id;
        handleAction(primaryAction.key, contextId, row);
      }
    },
    [actions, handleAction, meta?.id]
  );

  const onrowSelectionChanged = () => {
    const selectedRows = gridRef.current?.api?.getSelectedRows() || [];
    //console.log(selectedRows);
    setCheckedRows(selectedRows);
  };

  const onCellValueChanged = (params: any) => {
    if (params.colDef?.field !== "comments") {
      return;
    }
    const userId = params.data?.userId;
    const date = params.data?.date;
    const comments = params.newValue ?? "";
    if (!userId || !date) {
      return;
    }
    userService
      .onAddUserComment(userId, date, comments, 1)
      .then((response: any) => {
        if (response?.status === "success") {
          toast.success(response?.message || "Comment updated successfully");
        } else {
          toast.error(response?.message || "Failed to update comment");
          params.node.setDataValue("comments", params.oldValue);
        }
      })
      .catch(() => {
        toast.error("Failed to update comment");
        params.node.setDataValue("comments", params.oldValue);
      });
  };

  const onDocumentModalOpen = (data: any) => {
    if (!data?.reportType && data.documents.length == 0) {
      return;
    }
    setModalData(data);
    setActionType({key: "documentgrid"});
    setModalOpen(true);
  };

  const setSidebarReqData = (req: any) => {
    const fetchData = async () => {
      setIsLoading(true); // Start loading
      if (sidebar) {
        const apiUrl = url?.api?.get;

        const results = await tableService.onGet(apiUrl, 5, req);
        if (results) {
          setData(results);
          setItems(Array.isArray(results?.rows) ? results.rows : []);
          if (
            Array.isArray(results?.rows) &&
            results.rows.length > 0 &&
            meta?.id === 4
          ) {
            //meta?.id =4 === result
            const uidsArray = results.columns.map(
              (columnn: any) => columnn.uid
            );
            setColumns(results.columns);
            setActiveColumns(uidsArray);
          }
          setIsLoading(false); // Stop loading
        }
      }
    };
    fetchData();
  };

  const onChangeGroupingElement = (groupidData: {
    label: string;
    id: number;
    url: string;
  }) => {
    if (groupidData && groupidData?.url) {
      fetchData(groupidData.url);
    } else {
      fetchData();
    }
  };
  return (
    <>
      {sidebar && (
        <div className="h-[calc(100vh-100px)] w-[30%] bg-gray-100 p-2">
          {sidebar.map((sideBar: any, index: number) => {
            switch (sideBar.menu) {
              case "rfidLog":
                return (
                  <RfidLog
                    sideBar={sideBar}
                    request={sidbarRequest}
                    setSidebarReqData={setSidebarReqData}
                    // onApplyFilters={applyFilters}
                  />
                );
              case "distanceDriven":
                return (
                  <DrivenReport
                    sideBar={sideBar}
                    request={sidbarRequest}
                    setSidebarReqData={setSidebarReqData}
                  />
                );
              case "speedDeviation":
                return (
                  <SpeedDeviation
                    sideBar={sideBar}
                    request={sidbarRequest}
                    setSidebarReqData={setSidebarReqData}
                  />
                );
              // DistanceDeviationReport
              case "distanceDeviation":
                return (
                  <DistanceDeviationReport
                    sideBar={sideBar}
                    request={sidbarRequest}
                    setSidebarReqData={setSidebarReqData}
                  />
                );
              //tripStatus
              case "tripStatus":
                return (
                  <TripStatus
                    sideBar={sideBar}
                    request={sidbarRequest}
                    setSidebarReqData={setSidebarReqData}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
      )}
      <div className="flex-1 p-2">
        <div className="flex w-full flex-col gap-2 ">
          {/* <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "white",
            padding: "1rem",
            borderBottom: "1px solid #ddd"
          }}
        >
         
        </div> */}
          <NeoAGHeader
            onClear={onSearchChange} // need to chk
            onSearchChange={onSearchChange} // need to chk
            filterValue={quickFilterTextRef.current}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            statusOptions={statusOptions}
            count={items?.length ?? 0}
            meta={meta}
            url={url}
            onApplyFilters={applyFilters}
            onRowsPerPageChange={""} // need to chk
            onSortChange={""} //need to chk
            activeFilters={activeFilters}
            reportRequest={applyReportFilters}
            reportFilters={reportFilters}
            dashboardfilter={dashboardfilter}
            onChangeTab={onChangeTab}
            tabView={tabView}
            innerFilters={innerFilters}
            headerSidebar={headerSidebar}
            onExportClick={onExportClick}
            fullResponseData={data} //its use for top header or statistics
            setActivePanel={setActivePanel} //its used for icon based column sidebar show and hide operation
            activePanel={activePanel}
            openFormModal={openFormModal}
            checkedRows={checkedRows}
            rowSelection={rowSelection} //Its used for table row selection with checkbox
            otherDatas={otherDatas} // Additional data that might be needed for the table or request
          ></NeoAGHeader>
          {groupingFilter && groupingFilter.length > 0 && (
            <GroupingFilter
              groupingFilter={groupingFilter}
              selectedGroupingFilter={selectedGroupingFilter}
              onChangeGroupingElement={(data: any) => {
                setSelectedGroupingFilter(data);
                onChangeGroupingElement(data);
              }}
            />
          )}

          <div className="flex">
            <div
              className="ag-theme-alpine w-[80%] flex-grow"
              //style={{height: "80vh", width: "100%"}}
            >
              <AgGridReact
                onGridReady={handleGridReady}
                modules={[AllCommunityModule]}
                groupSuppressBlankHeader={true}
                ref={gridRef}
                rowData={items}
                columnDefs={headerColumns}
                pagination={true}
                rowSelection={rowSelection ? "multiple" : undefined}
                rowMultiSelectWithClick={rowSelection ? true : undefined}
                suppressRowClickSelection={rowSelection ? false : undefined}
                onSelectionChanged={onrowSelectionChanged}
                onCellValueChanged={onCellValueChanged}
                onRowDoubleClicked={onRowDoubleClicked}
                paginationPageSize={20}
                cacheQuickFilter={true}
                loading={isLoading}
                loadingOverlayComponent={LoadingOverlay}
                defaultColDef={{sortable: true}}
                paginationPageSizeSelector={[10, 20, 50, 100]}
              />
            </div>
            <SidebarDrawer
              columns={columns}
              setActiveColumns={setActiveColumns}
              activeColumns={activeColumns}
              items={items}
              activePanel={activePanel}
              setActivePanel={setActivePanel}
              // setSearchFilterText={setSearchFilterText}
            />
          </div>
        </div>
      </div>
      <NeoModal
        actionType={actionType?.key}
        onOpen={modalOpen}
        onClose={onModalClose}
        onModalSubmit={onModalSubmit}
        hasActions={
          actionType?.key == "delete" ||
          actionType?.key == "deactivate" ||
          actionType?.key == "resetpassword"
            ? true
            : false
        }
        selectedRow={rowsData}
        data={modalData}
      ></NeoModal>
    </>
  );
};

//AgGridReact start
//editType="fullRow"
//unSortIcon={true}

//sideBar={sideBardDef}
//sideBar={"columns"}
// domLayout="autoHeight"
// animateRows={true}
// paginationAutoPageSize={false}
// suppressPaginationPanel={false}
// suppressColumnVirtualisation={false}
//floatingFilter={true}
// domLayout="autoHeight"
//animateRows={true}
//modules={gridModules}
// sideBar={["columns"]}
//   sideBar={{
//     toolPanels: [
//       {
//         id: "columns",
//         labelDefault: "Columns",
//         labelKey: "columns",
//         iconKey: "columns",
//         toolPanel: "agColumnsToolPanel" // 👈 built-in, no import needed
//       }
//     ],
//     defaultToolPanel: "columns"
//   }}
//new strat
// defaultColDef={defaultColDef}
//   autoGroupColumnDef={autoGroupColumnDef}
//AgGridReact end
